import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, Input, ViewChild} from "@angular/core";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatFormFieldControlProxy} from "web-ng2/delt/material/MatFormFieldControlProxy";
import {TemaModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {harSammeId} from "felles-ng2/modell/modellHjelpere";
import {Subject} from "rxjs";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {TranslateModule} from "@ngx-translate/core";
import {MatSelectTipsKomponent} from "web-ng2/delt/komponenter/mat-select-tips/mat-select-tips";

const debug = initDebugger('VelgTemaKomponent');


/** Viser nedtrekksmeny med temaer.
 *
 * <pre>
 * Fungerer med Ng reactive form via ([(skjemakontroll)]="...").
 * Fungerer med <mat-form-field> fra Material.
 *
 * MERK at vi ikke implementerer ControlValueAccessor fra angular.forms, så komponenten vil ikke fungere med
 * [(ngModel)]="..." eller [formControl]="...".
 * </pre>
 */
@Component({
    selector: 'velg-tema',
    templateUrl: 'velg-tema.html',
    styleUrls: ['velg-tema.scss'],
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: VelgTemaKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny, komponent.stateChanges),
        deps: [VelgTemaKomponent]
    }],
    imports: [
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        MatSelectTipsKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgTemaKomponent implements AfterViewInit {

    @ViewChild('temavelger') private nedtrekksmeny!: MatSelect;

    @Input({required: true}) set temaer(temaer:TemaModell[]){
        this.setTemaer(temaer);
    }
    @Input({required: true}) skjemakontroll!: FormControl<TemaModell | null>;
    @Input() placeholder = '';

    aktiveTemaer: TemaModell[] = [];
    arkiverteTemaer: TemaModell[] = [];
    viserArkiverte = false;
    erValgt = harSammeId;

    private readonly stateChanges = new Subject<void>();

    constructor(private destroyRef: DestroyRef) {
    }

    visArkiverte(){
        this.viserArkiverte = true;
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny.stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
    }

    //hjelpemetoder

    private setTemaer(temaer:TemaModell[]){
        if (erNil(temaer)) return;
        this.aktiveTemaer = temaer.filter(tema => !tema.arkivert);
        this.arkiverteTemaer = temaer.filter(tema => tema.arkivert);
    }
}

